// extracted by mini-css-extract-plugin
module.exports = {"btn":"ApproveCredit_btn__1wGCa"};